export default {
  methods: {
    /**
     * @param {Date} date
     * @returns {{hours: number, seconds: number, minutes: number, days: number}}
     */
    counter(date) {
      const now = new Date().getTime();
      const distance = date.getTime() - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor((distance % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      return {days, hours, minutes, seconds};
    },

    formatDateDigit(digit) {
      return digit < 10 ? '0' + digit : digit;
    },

    formatDays(days) {
      return days === 1 ? 'dag' : 'dagen';
    },

    formatMinutes(minutes) {
      return minutes === 1 ? 'minuut' : 'minuten';
    },
  },
};
